import ProductBouquetRepository from "@adapters/features/Markets/OTC/Repository/ProductBouquet";
import TransactionJourneyRepository from "@adapters/features/Markets/OTC/Repository/TransactionJourney";
import OrderBookRepository from "@adapters/features/Markets/OTC/Repository/OrderBook";
import RegisterLeadRepository from "@adapters/features/Markets/OTC/Repository/RegisterLead";
export default (function (http) {
    return {
        productBouquet: new ProductBouquetRepository(http),
        transactionJourney: new TransactionJourneyRepository(http),
        orderBook: new OrderBookRepository(http),
        registerLead: new RegisterLeadRepository(http),
    };
});
